import { KubitNavigationRowVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    kubitNavigationRow: {
        variant: KubitNavigationRowVariantType.REGULAR,
    },
});
//# sourceMappingURL=commonStyles.js.map